export { default } from 'ember-cli-showdown/components/markdown-to-html';
